var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: {
        placeholder: _vm.placeholder,
        clearable: "",
        filterable: "",
        multiple: _vm.multiple,
        disabled: _vm.disabled,
      },
      on: { change: _vm.select },
      model: {
        value: _vm.selectedValue,
        callback: function ($$v) {
          _vm.selectedValue = $$v
        },
        expression: "selectedValue",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item[_vm.option.Id],
        attrs: { label: item[_vm.option.label], value: item[_vm.option.Id] },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }